import { ServiceConfigProviderSetup } from '@volkswagen-onehub/service-config-provider';
import {
  FAServicesParams,
  FetchServiceOptions,
} from '../types/service-configs';

function createFetchUrl(
  serviceURl: string | undefined,
  endpoint,
  params?: FAServicesParams,
): string {
  serviceURl = !serviceURl?.endsWith('/')
    ? serviceURl?.concat('/')
    : serviceURl;

  const query = new URLSearchParams();
  query.set('serviceConfigsServiceConfig', JSON.stringify(params));
  return `${serviceURl || ''}${endpoint}?${query}`;
}

export async function fetchServiceConfigs({
  serviceURl,
  endpoint,
  params,
}: FetchServiceOptions): Promise<ServiceConfigProviderSetup> {
  const url = createFetchUrl(serviceURl, endpoint, params);
  const response = await fetch(url);
  const configs = await response.json();

  if (response.status >= 500) {
    return { configs: {} };
  }
  return configs;
}
